import { useMutation } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'

export function useCreatePublicWitness() {
  return useMutation({
    mutationFn: async ({
      id_client,
      slot,
      name,
      cpf,
      local,
      maquina
    }: {
      id_client: string
      slot: 1 | 2
      name: string
      cpf: string
      local?: string
      maquina?: string
    }) => {
      const response = await publicApi.post(`/signatures/public/${id_client}/witness/${slot}`, {
        nome: name,
        cpf,
        local: local || '',
        maquina: maquina || ''
      })

      if (!response.data) throw new Error('Erro ao cadastrar testemunha')
      return response.data
    }
  })
}
